import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

interface SelectableTileGridProps {
  children: ReactNode
  className?: string
}

export const SelectableTileGrid: FC<SelectableTileGridProps> = ({
  children,
  className,
}) => <div className={clsx(s.grid, className)}>{children}</div>
